// IndianSubsidiaryRegistration.jsx
import React from "react";

export default function IndianSubsidiaryRegistration() {
  const handleWhatsAppClick = () => {
    const phoneNumber = "919217468906"; // without +
    const message =
      "Hello! I would like to get a consultation for Indian Subsidiary Registration.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Indian Subsidiary
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Indian Subsidiary Registration in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks helps foreign entities establish Indian
            subsidiaries in line with Indian corporate law and FDI regulations,
            enabling international businesses to operate through a locally
            incorporated company with a distinct legal identity. [web:21][web:29]
          </p>
          <p className="text-gray-700">
            From selecting the right subsidiary structure and drafting charter
            documents to coordinating with authorities on incorporation and FDI
            reporting, the team offers structured support throughout the entry
            and setup process. [web:21][web:27]
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/5668830/pexels-photo-5668830.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Foreign company discussing Indian subsidiary setup"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Indian Subsidiary Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks guides both the foreign parent and proposed
              Indian directors in compiling notarised and apostilled documents,
              ensuring they meet incorporation and FDI compliance norms. [web:21][web:22]
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Parent company charter documents (Certificate of Incorporation,
                  Memorandum and Articles, or equivalent), duly notarised /
                  apostilled as required. [web:21][web:23]
                </li>
                <li>
                  Board resolution of the foreign parent approving formation of
                  the Indian subsidiary and authorising representatives. [web:21][web:22]
                </li>
                <li>
                  Identity and address proof of proposed directors (passport,
                  address proof, photographs). [web:22][web:24]
                </li>
                <li>
                  PAN of Indian directors and tax identification of foreign
                  directors, as applicable. [web:22][web:29]
                </li>
                <li>
                  Registered office address proof in India (rent agreement or
                  ownership documents, latest utility bill, and NOC from owner).
                  [web:21][web:22]
                </li>
                <li>
                  Digital Signature Certificates (DSC) and Director
                  Identification Numbers (DIN) for proposed directors. [web:21][web:22]
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm combines cross‑border structuring experience with
              knowledge of Indian company law and FEMA/RBI rules, offering
              foreign businesses a clear roadmap for setting up in India. [web:21][web:30]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Cross‑Border Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on Companies Act requirements, FDI norms, and RBI
                  reporting, including share allotment and foreign capital
                  inflow timelines. [web:21][web:27]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Structured Incorporation Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance across name approval, drafting MoA and AoA, filing
                  incorporation forms, and obtaining the Certificate of
                  Incorporation and CIN for the subsidiary. [web:21][web:24]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Regulatory Guidance
                </h3>
                <p className="text-gray-700 text-sm">
                  Ongoing advisory on annual filings, corporate governance, and
                  sector‑specific approvals so the subsidiary stays compliant
                  after setup as well. [web:21][web:27]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <button
                type="button"
                onClick={handleWhatsAppClick}
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </button>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
